import { render, staticRenderFns } from "./tableKedisiplinan.vue?vue&type=template&id=6df2185e&scoped=true"
import script from "./tableKedisiplinan.vue?vue&type=script&lang=js"
export * from "./tableKedisiplinan.vue?vue&type=script&lang=js"
import style0 from "./tableKedisiplinan.vue?vue&type=style&index=0&id=6df2185e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2185e",
  null
  
)

export default component.exports